module.exports = __webpack_public_path__ + "static/media/federal-election-driver.506413e9.png";